/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Microsoft 365 Calendar" |
*
* @param {Connections_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_microsoft = /** @type {((inputs?: Connections_MicrosoftInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_MicrosoftInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microsoft 365 Calendar")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Microsoft 365 Calendar")
	return /** @type {LocalizedString} */ ("Microsoft 365 Calendar")
});